import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

import React from "react";

const BlogCard = ({
  title,
  subtitle,
  info,
  to,
  image,
  category,
  className = "",
  size = "sm",
}) => {
  if (size === "lg") {
    return (
      <Link
        to={to}
        className={`col-span-12 flex flex-col items-center w-full overflow-hidden bg-white border-2 border-black md:flex-row hover:shadow-xl duration-150 ease-out transform ${className}`}
      >
        <div className="flex flex-col w-full p-10 mt-4 text-center md:w-1/2 md:mt-0">
          <p className="mb-4 text-sm uppercase font-bold text-grey-700 leading-none">
            {category}
          </p>
          <h2 className="max-w-md mx-auto mb-6 text-4xl font-semibold md:leading-tight lg:text-5xl">
            {title}
          </h2>
          <p className="mb-4 md:mb-8 text-sm font-medium tracking-widest">
            {subtitle}
          </p>
          <div className="flex items-center w-auto mx-auto text-lg leading-tight text-center text-blue-600 hover:underline">
            <span>Read Now</span>
            <svg
              className="w-3 h-3 mt-0.5 ml-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </div>
        </div>
        <div className="w-full h-full mt-2 md:w-1/2 md:mt-0">
          <GatsbyImage
            className="object-cover w-full h-full"
            image={image}
            alt={`Cover image of ${title}`}
          />
        </div>
      </Link>
    );
  }

  if (size === "md") {
    return (
      <Link
        to={to}
        className={`col-span-12 md:col-span-6 flex flex-col items-center justify-center flex-1 overflow-hidden text-center bg-white border-2 border-black hover:shadow-xl duration-150 ease-out transform ${className}`}
      >
        <div className="flex flex-col px-10 pb-5 space-y-6 pt-14 md:px-8">
          <p className="mb-4 text-sm uppercase font-bold text-grey-700 leading-none">
            {category}
          </p>
          <h3 className="text-2xl font-semibold leading-none md:text-3xl">
            {title}
          </h3>
          <p className="text-xl font-light">{info}</p>
          <div className="flex items-center w-auto mx-auto text-lg leading-tight text-center text-blue-600 hover:underline">
            <span>Learn more</span>
            <svg
              className="w-4 h-4 ml-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </div>
        </div>
        <div className="w-2/3 mx-auto">
          <GatsbyImage
            className="object-cover w-full h-full"
            image={image}
            alt={`Cover image of ${title}`}
          />
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={to}
      className={`relative col-span-12 duration-150 ease-out transform border-2 bg-white border-black cursor-pointer md:col-span-6 lg:col-span-4 hover:shadow-xl ${className}`}
    >
      <div className="block h-64 overflow-hidden">
        <GatsbyImage
          className="object-cover w-full h-full"
          image={image}
          alt={`Cover image of ${title}`}
        />
      </div>
      <div className="p-5 pb-6">
        <h2 className="mb-2 text-2xl font-bold leading-tight tracking-tight">
          {title}
        </h2>
        <p className="mb-2 text-sm font-medium tracking-widest text-grey-700">
          {subtitle}
        </p>
        <p>
          <span>{info}</span>
        </p>
      </div>
    </Link>
  );
};

export default BlogCard;
